import { Box, Container, Stack, Typography } from "@mui/material";

type DisbursementCoolingOffProps = {
    coolOffDays: number | undefined;
    firstName: string | undefined;
}

const DisbursementCoolingOff: React.FunctionComponent<DisbursementCoolingOffProps> = (props: DisbursementCoolingOffProps) => {
    return (
        <Container disableGutters sx={{ paddingX: '1.6rem' }}>
            <Stack>
                <Typography

                    variant="h1"
                    fontSize={{ md: '3.2rem', xs: '2.4rem' }}
                    marginBottom={'1.6rem'}
                    fontWeight={400}
                    lineHeight={{ md: '3.5rem', xs: '2.5rem' }}
                >
                    <Stack
                        flexDirection={'row'}
                        gap={'1rem'}
                    >

                        Hi
                        <Box
                            textTransform={'capitalize'}
                        >
                            {props.firstName?.toLowerCase()}
                        </Box>
                    </Stack>
                </Typography>
                <Typography
                    variant="body1"
                    fontSize={'1.8rem'}
                    marginBottom={'1.6rem'}
                    lineHeight={'2.3rem'}
                >
                    Thanks for repaying your last loan.
                </Typography>

                <Typography
                    fontWeight={300}
                >
                    You’re not able to apply just yet. You can re-apply for a new loan in {props.coolOffDays} days.
                </Typography>
            </Stack>
        </Container>
    );
}

export default DisbursementCoolingOff;